import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Guia } from "src/app/models/Guia";

@Component({
  selector: "app-item-navegacao-aba-leis",
  templateUrl: "./item-navegacao-aba-leis.component.html",
  styleUrls: ["./item-navegacao-aba-leis.component.scss"],
})
export class ItemNavegacaoAbaLeisComponent {
  @Output() selecionarAbaLei = new EventEmitter<Guia>();
  @Output() fecharAbaLei = new EventEmitter<Guia>();

  @Input() item: Guia;

  constructor() {}

  public selecionarLei(evt: Event): void {
    evt.stopPropagation();
    this.selecionarAbaLei.emit(this.item);
  }

  public fecharLei(evt: Event): void {
    evt.stopPropagation();
    this.fecharAbaLei.emit(this.item);
  }
}
